import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import refreshQueues from '../../lib/refreshQueues';
import setQueueStatus from './setQueueStatus';
import { removeSessionFromQueue } from './queueSessionUtils';

async function handleQueueSessionLeft(event: Telecom.QueueSessionLeftEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:session_left:' + queue?.name, event);

  if (!queue) {
    await refreshQueues();
    return;
  }

  removeSessionFromQueue({
    queue,
    event,
    logPrefix: 'rtcs:queue:session_left',
    handlerName: 'handleQueueSessionLeft',
  });
  setQueueStatus(queue, event);
}

export default handleQueueSessionLeft;
